import { IconLink } from '@xingternal/icons';
import { isBlockActive } from '@xingternal/content-editor-plugin-helpers';

import { insertLink, isLinkActive, currentLinkHref, unwrapLink } from './utils';

const buttonConfig = ({
  disabledForBlockTypes = [],
  icon = IconLink,
  label = 'Link',
  message = 'Please enter a web address.',
  ...props
} = {}) => ({
  isHighlighted: (editor) => isLinkActive(editor),
  isDisabled: (editor) =>
    disabledForBlockTypes.some((element) => isBlockActive(editor, element)),
  icon,
  label,
  onClick: (event, editor) => {
    event.preventDefault();
    let initialValue = currentLinkHref(editor);
    const url = window.prompt(message, initialValue);
    if (url === null) return;
    if (url === '') unwrapLink(editor);
    if (url) insertLink(editor, url);
  },
  ...props,
});

export { buttonConfig };
